<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Teater',

    metaInfo: { title: 'Teater' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'liket2025',
        'signalfel',
        'borensbergsrevyn',
        'hjalpvivillhem',
        'tillminkarafiende',
        'liket',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'teater',
      },
    },
  }
</script>
